module.exports = __webpack_public_path__ + "img/bigScreenFont@2x.213ef95b.gif";